
export function downloadApkPackage(packageName: any, ext: string = "apk") {
  var downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", 'resources/app-debug.apk');
  downloadAnchorNode.setAttribute("download", `${packageName}.${ext}`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}
